<div class="notificationMenuItem">

  <button class="notificationButton" (click)="pressed()" mat-button color="primary">
    <img *ngIf="notification.icon !==''" class="icon" [src]="notification.icon" alt="">
    <mat-icon *ngIf="notification.matIcon !==''"> {{notification.matIcon}} </mat-icon>
    {{notification.message}}
  </button>
</div>
